import React, { Component } from "react";
import Settings from "../../services/settings.service";
import { t } from "../../services/translation.service";
import {format_number} from "../../services/plans.service";
export default class Spec extends Component {
  render() {
    let prefix = Settings.plans_prefix;
    let spec = this.props.spec;
    let val = null;
    let type = null;
    if (spec) {
      val = spec[prefix + "ValueFormatted"];
      type = spec["Type"];
    }

    if(val === "Unlimited") {
      val = "";
    }
    let type_friendly = Settings.types_human_map[type];

    let unit = "min/SMS";
    if (val === Settings.unlimited_text) {
      unit = "min";
    }

    if (type === "DATA") {
      unit = spec[prefix + "UnitFormatted"];
    }

    let extra = this.props.extra;

    let values_html = "";
    let icon = "";
    let icon_class = "";

    if (
      spec && this.props.override_img &&
      spec["ExtraDetails"] &&
      spec["ExtraDetails"][this.props.override_img]
    ) {
      icon_class = "vmo-modem-img-img";
      icon = (
        <div className="vmo-modem-img">
          <img alt="" src={spec["ExtraDetails"][this.props.override_img]} />
        </div>
      );
    } else {
      icon_class = "vmo-modem-img-css";
    }

    let label = "";

    let price_html = "";

    if (this.props.price) {
      let label = (this.props.duration ===1) ? t("DATA_PRICE_LABEL") : t("DATA_PRICE_LABEL_12");
      if (type_friendly === "modem") {
        label = t("MODEM_PRICE_LABEL");
      }
      price_html = (
        <div className="vmo-plan-spec vmo-plan-spec-payment">
          <span className="vmo-plan-spec-value">AED {format_number(this.props.plan_price)}</span>
          <span className="vmo-plan-spec-label">{label}</span>
        </div>
      );
    } else {
      if (this.props.summary) {
        if (type === "DATA") {
          label = t("SUMMARY_MOBILE_DATA_LABEL");
        }

        if (type === "VOICE-LCL") {
          label =
            val === Settings.unlimited_text
              ? t("SUMMARY_LOCAL_LABEL_UNLIMIT")
              : t("SUMMARY_LOCAL_LABEL");
        }

        if (type === "VOICE-INT") {
          label =
            val === Settings.unlimited_text
              ? t("SUMMARY_INTERNATIONAL_LABEL_UNLIMIT")
              : t("SUMMARY_INTERNATIONAL_LABEL");
        }
      } else {
        label = t(type) + "" + (type !== "DATA" ? unit : "") + " ";
      }
    }

    if (this.props.override_val && spec && spec[this.props.override_val]) {
      values_html = (
        <div
          key={type}
          className={
            "vmo-plan-spec vmo-plan-spec vmo-plan-spec-" +
            type_friendly +
            " " +
            icon_class
          }
        >
          {icon}
          <span className="vmo-plan-spec-value">
            {spec?.ExtraDetails?.Name}
          </span>
        </div>
      );
    } else {
      values_html = (
        <div
          key={type}
          className={
            "vmo-plan-spec vmo-plan-spec-" + type_friendly + " " + icon_class
          }
        >
          {icon}
          <span className="vmo-plan-spec-value">
            {val}
            {this.props.suffix ? this.props.suffix : ""}
            {type !== "DATA" ? " " : ""}
            {type === "DATA" ? unit : ""}{" "}
          </span>
          {extra ? (
            <span className="vmo-plan-spec-extra">
              +{extra}
              {type === "DATA" ? unit : ""} Free{" "}
            </span>
          ) : (
            ""
          )}
          <span className="vmo-plan-spec-label">{label}</span>
        </div>
      );
    }

    return (
      <>
        {values_html}
        {price_html}
      </>
    );
  }
}
